import { SvgIcon } from '@mui/material';
import { motion } from 'motion/react';
import { forwardRef } from 'react';

import type { AnimatedIconProps, AnimeatableIconRef } from './types';
import { pathVariants } from './types';
import { useAnimatedIcon } from './useAnimatedIcon';

const MapIcon = forwardRef<AnimeatableIconRef, AnimatedIconProps>(
  ({ size = 28, strokeWidth = 2, titleAccess, color }, ref) => {
    const controls = useAnimatedIcon(ref);

    return (
      <SvgIcon
        titleAccess={titleAccess}
        color={color}
        sx={{ width: size, height: size }}
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <motion.path
            variants={pathVariants}
            initial="visible"
            animate={controls}
            custom={0}
            d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z"
          />
          <motion.path
            variants={pathVariants}
            initial="visible"
            animate={controls}
            custom={1}
            d="M15 5.764v15"
          />
          <motion.path
            variants={pathVariants}
            initial="visible"
            animate={controls}
            custom={2}
            d="M9 3.236v15"
          />
        </svg>
      </SvgIcon>
    );
  }
);

MapIcon.displayName = 'MapIcon';

export { MapIcon };
